import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { WeblinkMainComponent } from '../weblink-main/weblink-main.component';

@Injectable()
export class CanDeactivateWeblinkGuard implements CanDeactivate<WeblinkMainComponent> {
  canDeactivate(
    component: WeblinkMainComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean>|Promise<boolean>|boolean {
    return true;
  }
}

